import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import { bePosTipsRead } from 'actions/pos/bePosTips.action';
import { feTipsFoldToggle } from 'actions/ui.actions';
import Button from 'components/form/Button.component';
import Badge from 'components/generic/Badge.component';
import Icon from 'components/generic/Icon.component';
import LINK from 'constants/link.const';
import { usePrepareReadOnly } from 'hooks/usePrepare.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';

import CN from './TipPosBanner.module.scss';

const TipPosBanner = ({ feTipsFoldToggle }) => {
  const history = useHistory();
  const salonId = useCurrentSalonId();
  const nav = navFor('MobileStylistPanel.handleWeekView()', { history });
  const { t } = useTranslation();

  const { qj } = usePrepareReadOnly(bePosTipsRead);
  const isTipOn = fromAnyToBool(qj?.takeTipViaPos);

  const handleGoToTips = useCallback(() => {
    nav.push({
      pathname: linkTo({ pattern: LINK.salonOnline, params: { salonId } }),
    });
    feTipsFoldToggle();
  }, [feTipsFoldToggle, nav, salonId]);

  return (
    <div
      data-bem="TipPosBanner"
      className={cn({
        [CN.component]: true,
        [CN.isOff]: !isTipOn,
      })}
    >
      <div data-bem="TipPosBanner-text" className={CN.text}>
        <span className={CN.statusTitle}>{t('slickPay.tippingCard.title')}</span>
        <div className={CN.badgeContainer}>
          {isTipOn ? (
            <Badge variant="success" invertedDark>
              <div className={CN.badgeContent}>
                <Icon variant="checkCircleSolid" width="md" />
                <span className={CN.badgeText}>{t('slickPay.tippingCard.statuses.enabled')}</span>
              </div>
            </Badge>
          ) : (
            <Badge variant="draft">
              <div className={CN.badgeContent}>
                <Icon variant="xCircleSolid" width="md" />
                <span className={CN.badgeText}>{t('slickPay.tippingCard.statuses.disabled')}</span>
              </div>
            </Badge>
          )}
          <div className={CN.buttonGoToTipsSettings}>
            <Button variant="secondaryForce" onClick={handleGoToTips} xSpace>
              <div className={CN.flex}>
                <Icon variant="pencil" selected width="md" />
                <div className={CN.buttonInnerText}>{t('common.buttons.manage')}</div>
              </div>
            </Button>
          </div>
        </div>

        <span className={CN.description}>{t('slickPay.tippingCard.description')}</span>
      </div>
    </div>
  );
};

const TipPosBannerHoc = connect(
  null,
  mapActionsToDispatchToProps({
    feTipsFoldToggle,
  }),
)(TipPosBanner);

export default TipPosBannerHoc;
